export const GET_ERRORS = "GET_ERRORS";
export const USER_LOADING = "USER_LOADING";
export const SET_CURRENT_USER = "SET_CURRENT_USER";

export const AUTHENTICATION_PASSWORD_RESET_HASH_CREATED =
  "AUTHENTICATION_PASSWORD_RESET_HASH_CREATED";
export const AUTHENTICATION_PASSWORD_RESET_HASH_FAILURE =
  "AUTHENTICATION_PASSWORD_RESET_HASH_FAILURE";
export const AUTHENTICATION_PASSWORD_RESET_CLEAR =
  "AUTHENTICATION_PASSWORD_RESET_CLEAR";

export const SET_SELECTED_AREA = "SET_SELECTED_AREA";
export const SET_SELECTED_SLIDE_TYPE = "SET_SELECTED_SLIDE_TYPE";
export const SET_SELECTED_SLIDE = "SET_SELECTED_SLIDE";
export const SET_SELECTED_PORTAL = "SET_SELECTED_PORTAL";
export const SET_SELECTED_CHANNEL = "SET_SELECTED_CHANNEL";
export const SET_SELECTED_USER = "SET_SELECTED_USER";
export const SET_SELECTED_TEMPLATE = "SET_SELECTED_TEMPLATE";
export const SET_SELECTED_CL_CATEGORY = "SET_SELECTED_CL_CATEGORY";
